import * as React from 'react'
import CloudinaryImage from 'web-makeup/dist/CloudinaryImage'
import { Margin, Padding } from 'web-makeup/dist/design-system/styles/spacings'
import { isAdmin, isManager, isProducer } from 'web-fns/dist/auth'

import { User } from '../../../../typings/types'
import { getLastOnlineStatus } from '../../../../helpers/timeAgoHelper'

import EnvironmentContext from '../../../EnvironmentContext'

import { PositionDefaultRole, PositionSecurityLevel } from '../../enums/brand-dashboard'

import {
  Wrapper,
  ImageHolder,
  StyledText,
  TagBar,
  Tag,
  ActionIconsCnt,
  ActionIconsWrapper,
  ActionIcon,
  Divider,
  IconWrapper,
} from './card.style'

interface ShootDetailsProps {
  user: User
  role: PositionDefaultRole
  level: PositionSecurityLevel
  isCurrentUser?: boolean
  editUser?: () => void
  onDeleteIcon?: () => void
}

export const Card: React.FC<ShootDetailsProps> = ({
  user,
  role,
  level,
  isCurrentUser,
  editUser,
  onDeleteIcon,
}) => {
  const { avatar, name, location, phoneNumber, skypeUsername, email, id: userId, lastVisitAt } =
    user || ''
  const lastVisitAtDate = lastVisitAt ? new Date(lastVisitAt) : null
  const deleteIcon = (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_19833_36300)">
        <path
          d="M4.33537 13.5625C3.66675 13.5625 3.09948 13.034 3.04419 12.3585L2.27882 3.0625H1.38041C1.14199 3.0625 0.948486 2.8665 0.948486 2.625C0.948486 2.3835 1.14199 2.1875 1.38041 2.1875H4.83583V1.75C4.83583 1.02608 5.41691 0.4375 6.13161 0.4375H8.72317C9.43786 0.4375 10.0189 1.02608 10.0189 1.75V2.1875H13.4744C13.7128 2.1875 13.9063 2.3835 13.9063 2.625C13.9063 2.8665 13.7128 3.0625 13.4744 3.0625H12.576L11.8112 12.3591C11.7559 13.034 11.1886 13.5625 10.52 13.5625H4.33537ZM3.90459 12.2862C3.92302 12.5113 4.11192 12.6875 4.33537 12.6875H10.52C10.7429 12.6875 10.9323 12.5113 10.9502 12.2862L11.7092 3.0625H3.14555L3.90459 12.2862ZM9.1551 2.1875V1.75C9.1551 1.5085 8.96159 1.3125 8.72317 1.3125H6.13161C5.89318 1.3125 5.69968 1.5085 5.69968 1.75V2.1875H9.1551Z"
          fill="#BABABA"
        />
        <path
          d="M6.13163 10.5C5.89321 10.5 5.69971 10.304 5.69971 10.0625V5.6875C5.69971 5.446 5.89321 5.25 6.13163 5.25C6.37006 5.25 6.56356 5.446 6.56356 5.6875V10.0625C6.56356 10.304 6.37006 10.5 6.13163 10.5Z"
          fill="#BABABA"
        />
        <path
          d="M8.72319 10.5C8.48476 10.5 8.29126 10.304 8.29126 10.0625V5.6875C8.29126 5.446 8.48476 5.25 8.72319 5.25C8.96161 5.25 9.15511 5.446 9.15511 5.6875V10.0625C9.15511 10.304 8.96161 10.5 8.72319 10.5Z"
          fill="#BABABA"
        />
      </g>
      <defs>
        <clipPath id="clip0_19833_36300">
          <rect width="13.8217" height="14" fill="white" transform="translate(0.516602)" />
        </clipPath>
      </defs>
    </svg>
  )
  const editIcon = (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_15027_16074)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.48691 0.121212L12.0526 2.62626C12.194 2.76768 12.2142 3.0303 12.0526 3.17172L10.8808 4.38384C10.8808 4.40404 10.8606 4.42424 10.8404 4.44444C10.8303 4.45455 10.8202 4.4596 10.8101 4.46465C10.8 4.4697 10.7899 4.47475 10.7798 4.48485L4.4162 11.1111L4.396 11.1313C4.3859 11.1414 4.3758 11.1465 4.3657 11.1515C4.3556 11.1566 4.3455 11.1616 4.3354 11.1717C4.3354 11.1919 4.31519 11.1919 4.31519 11.1919C4.30509 11.1919 4.29499 11.197 4.28489 11.202C4.27479 11.2071 4.26469 11.2121 4.25459 11.2121H4.23439L1.00206 11.9798C0.981863 12 0.941459 12 0.921257 12C0.820246 12 0.719236 11.9596 0.638428 11.8788C0.537417 11.7778 0.497013 11.6364 0.537417 11.5152L1.3657 8.18182V8.16162C1.3657 8.12121 1.3657 8.10101 1.3859 8.08081V8.06061C1.4061 8.0202 1.42631 8 1.44651 7.9798L7.70913 1.43434C7.70913 1.41414 7.70913 1.41414 7.72934 1.39394L7.74954 1.37374L8.92125 0.121212C9.00206 0.0404041 9.10307 0 9.20408 0C9.30509 0 9.4061 0.0404041 9.48691 0.121212ZM1.93136 9.0303L1.42631 11.0505L3.3859 10.5859L1.93136 9.0303ZM8.55762 1.65657L10.5576 3.61616L11.2445 2.90909L9.24449 0.949495L8.55762 1.65657ZM2.25397 2.56564H0.90044C0.678218 2.56564 0.516602 2.38382 0.516602 2.1818C0.516602 1.97978 0.678218 1.79796 0.90044 1.79796H2.25397V0.404026C2.25397 0.202005 2.43579 0.0201874 2.63781 0.0201874C2.83983 0.0201874 3.02165 0.181803 3.02165 0.404026V1.79796H4.37519C4.57721 1.79796 4.75902 1.97978 4.75902 2.1818C4.75902 2.38382 4.59741 2.56564 4.37519 2.56564H3.02165V3.95958C3.02165 4.1616 2.83983 4.34342 2.63781 4.34342C2.43579 4.34342 2.25397 4.1818 2.25397 3.95958V2.56564Z"
          fill="#BABABA"
        />
      </g>
      <defs>
        <clipPath id="clip0_15027_16074">
          <rect width="12" height="12" fill="white" transform="translate(0.516602)" />
        </clipPath>
      </defs>
    </svg>
  )

  const env = window.env || {}
  const { CLOUDINARY_DOWNLOAD_URL } = env
  const userAvatar =
    avatar && avatar.cloudinaryType === 'upload'
      ? `${CLOUDINARY_DOWNLOAD_URL}/upload/r_max,f_png,q_auto,c_thumb,fl_lossy,fl_progressive/${
          avatar.cloudinaryId
        }`
      : (avatar && avatar.cloudinaryId && decodeURIComponent(avatar.cloudinaryId)) || ''
  const isBrand = !(isAdmin() || isProducer() || isManager())
  const { GEN1_BASE_URL } = React.useContext(EnvironmentContext) || ''

  const redirectToUserProfile = !isBrand
    ? () => window.open(GEN1_BASE_URL && `${GEN1_BASE_URL}/humans/${userId}/edit`, '_blank')
    : undefined

  return (
    <Wrapper isCurrentUser={!!isCurrentUser}>
      {isCurrentUser ? (
        <div>
          {' '}
          <Tag>You</Tag>
        </div>
      ) : (
        lastVisitAtDate &&
        getLastOnlineStatus(lastVisitAtDate.toISOString()) !== '' && (
          <div>
            <Tag isOnline={getLastOnlineStatus(lastVisitAtDate.toISOString()) === 'Online'}>
              {getLastOnlineStatus(lastVisitAtDate.toISOString())}
            </Tag>
          </div>
        )
      )}
      <TagBar>
        <div>
          {/* <IconWrapper onClick={() => alert('hideIcon')}>{hideIcon}</IconWrapper> */}
          {!(isCurrentUser && isBrand) && (
            <IconWrapper onClick={onDeleteIcon}>{deleteIcon}</IconWrapper>
          )}
          {!isBrand && <IconWrapper onClick={editUser}>{editIcon}</IconWrapper>}
        </div>
      </TagBar>
      <ImageHolder
        style={{ cursor: isBrand ? 'auto' : 'pointer' }}
        image={userAvatar}
        onClick={redirectToUserProfile}
      />
      <Margin top size="small">
        <StyledText
          className="desc"
          as="h5"
          fontSize="h5"
          color="black1"
          fontWeight="bold"
          textAlign="center"
          onClick={redirectToUserProfile}
          style={{ cursor: isBrand ? 'auto' : 'pointer' }}
        >
          {name}
        </StyledText>
      </Margin>
      <StyledText
        as="h6"
        fontSize="h7"
        lineHeight="small"
        color="black1"
        textAlign="center"
        textTransform="uppercase"
      >
        {location && location.city !== null && `${location.city}, `}
        {location && location.country !== null && location.country}
      </StyledText>
      <ActionIconsCnt>
        <ActionIconsWrapper>
          {email && (
            <Padding right left size="mSmall">
              <ActionIcon href={`mailto:${email}`}>
                <CloudinaryImage
                  useSourceFormat
                  source={{
                    id: '-design-system/icon-talk-black.svg',
                    type: 'upload',
                  }}
                />
              </ActionIcon>
            </Padding>
          )}
          {phoneNumber && (
            <Padding right left size="mSmall">
              <ActionIcon href={`tel:${phoneNumber}`}>
                <CloudinaryImage
                  useSourceFormat
                  source={{
                    id: '-design-system/icon-call.svg',
                    type: 'upload',
                  }}
                />
              </ActionIcon>
            </Padding>
          )}
          {skypeUsername && (
            <Padding right left size="mSmall">
              <ActionIcon href={`skype:${skypeUsername}?call`}>
                <CloudinaryImage
                  useSourceFormat
                  source={{
                    id: '-design-system/icon-online-video.svg',
                    type: 'upload',
                  }}
                />
              </ActionIcon>
            </Padding>
          )}
        </ActionIconsWrapper>
      </ActionIconsCnt>
      <Divider />
      <StyledText
        as="h6"
        fontSize="h6"
        lineHeight="small"
        color="black1"
        textAlign="center"
        fontWeight="bold"
      >
        {PositionDefaultRole[role]} - {PositionSecurityLevel[level]}
      </StyledText>
    </Wrapper>
  )
}



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/TeamCard/card.tsx